import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from './Auth.context';

interface AuthProps {
  children?: React.ReactNode;
}

const AuthProvider: React.FC<AuthProps> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('token') && window.location.pathname !== '/login')
      navigate('/login');
  }, [navigate]);

  const handleLogout = () => localStorage.removeItem('token');

  return (
    <AuthContext.Provider value={{ handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
